var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.val)?_c('div',{attrs:{"id":"detailsItem"}},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('span',[_vm._v(_vm._s(_vm.val))])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }